export default "__VITE_ASSET__Mz4i7q5d__"